var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"size":"lg","title":_vm.getCurrentGroupTitle,"centered":"","role":"dialog","ok-only":"","visible":_vm.isShown},on:{"hide":_vm.closeModal}},[_c('area-notes-form'),_c('area-notes-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }